import { render, staticRenderFns } from "./DormitoryUserDetailDialog.vue?vue&type=template&id=3440c91a&scoped=true&"
import script from "./DormitoryUserDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DormitoryUserDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryUserDetailDialog.vue?vue&type=style&index=0&id=3440c91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440c91a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VRow,VSpacer})
